webpackJsonp([38086154558686],{

/***/ 1315:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"StockTransferRequestItemFulfillmentStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"COLLECTED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DRAFT"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"PARTIAL"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"READY"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-stock-transfer-request-item-fulfillment-status-164c21a3ccf021407391.js